//production
module.exports.environment = {
    serverURL: "https://sugoi-toolkit-database-acqc8.ondigitalocean.app/"
}

//development
// module.exports.environment = {
//     serverURL: "http://localhost:9500/"
// }